export const demoMetricsKeys = {
  POWER_ACTIVE_W: 'POWER_ACTIVE_W',
  CURRENT_RMS_mA: 'CURRENT_RMS_mA',
  VOLTAGE_RMS_mV: 'VOLTAGE_RMS_mV',
};

export const demoMetrics = [
  { value: demoMetricsKeys.POWER_ACTIVE_W, label: 'Present Power' },
  { value: demoMetricsKeys.CURRENT_RMS_mA, label: 'Present Load' },
  { value: demoMetricsKeys.VOLTAGE_RMS_mV, label: 'Present Voltage' },
];

export const demoMetricDictionary = [
  {
    uuid: 1,
    code: 'POWER_ACTIVE_W',
    title: 'Present Power',
    units: 'kW',
    meter: 'EVPLCCom-Virtual-Meter-1',
    status: 'ACTIVE',
    accuracy: 3,
    multiplicator: 0.001,
  },
  {
    uuid: 2,
    code: 'CURRENT_RMS_mA',
    title: 'Present Load',
    units: 'A',
    meter: 'ECR380D',
    status: 'ACTIVE',
    accuracy: 2,
    multiplicator: 0.001,
  },
  {
    uuid: 3,
    code: 'VOLTAGE_RMS_mV',
    title: 'Present Voltage',
    units: 'V',
    meter: '',
    status: 'ACTIVE',
    accuracy: 2,
    multiplicator: 0.001,
  },
];

export const minValues = {
  [demoMetricsKeys.POWER_ACTIVE_W]: 7200,
  [demoMetricsKeys.CURRENT_RMS_mA]: 29500,
  [demoMetricsKeys.VOLTAGE_RMS_mV]: 229000,
};
export const maxValues = {
  [demoMetricsKeys.POWER_ACTIVE_W]: 7800,
  [demoMetricsKeys.CURRENT_RMS_mA]: 33500,
  [demoMetricsKeys.VOLTAGE_RMS_mV]: 241000,
};
export const VALUES = {
  min: minValues,
  max: maxValues,
  avg: {
    [demoMetricsKeys.POWER_ACTIVE_W]:
    (minValues[demoMetricsKeys.POWER_ACTIVE_W] + maxValues[demoMetricsKeys.POWER_ACTIVE_W]) / 2,
    [demoMetricsKeys.CURRENT_RMS_mA]:
    (minValues[demoMetricsKeys.CURRENT_RMS_mA] + maxValues[demoMetricsKeys.CURRENT_RMS_mA]) / 2,
    [demoMetricsKeys.VOLTAGE_RMS_mV]:
    (minValues[demoMetricsKeys.VOLTAGE_RMS_mV] + maxValues[demoMetricsKeys.VOLTAGE_RMS_mV]) / 2,
  },
};
export const DEVIATIONS = {
  [demoMetricsKeys.POWER_ACTIVE_W]: 200,
  [demoMetricsKeys.CURRENT_RMS_mA]: 1000,
  [demoMetricsKeys.VOLTAGE_RMS_mV]: 3000,
};

export const METRIC_CODES = Object.keys(demoMetricsKeys);
